export const COMPANY_ID_PATH_PARAM = ':companyId';

export const ROUTES = {
  COMPANY_BY_ID: `/companies/${COMPANY_ID_PATH_PARAM}`,
};

export const REDUCER_PATH = 'companyApi';
